// public/js/components/file-upload.js

const CLASSES = {
  container: {
    default: ['bg-white', 'border-slate-300', 'border-dashed'],
    active: ['bg-teal-50', 'border-teal-500', 'border-solid'],
    invalid: ['bg-red-50', 'border-red-600', 'border-dashed'],
  },
};

const MAX_SIZE = 50 * 1024 * 1024;

export default function FileUpload(rootEl) {
  const input = rootEl.querySelector('input[type="file"]');
  const defaultView = rootEl.querySelector('[data-ref="default"]');
  const selectedView = rootEl.querySelector('[data-ref="selected"]');
  const filenameEl = rootEl.querySelector('[data-ref="filename"]');
  const clearBtn = rootEl.querySelector('[data-action="clear-input"]');
  const triggerLabel = rootEl.querySelector(`label[for="${input?.id}"]`);
  const errorDiv = rootEl.querySelector('[data-ref="error"]');

  const isServerFile = rootEl.dataset.serverFile === 'true';

  const setError = (msg) => {
    if (!errorDiv) return;
    if (msg) {
      errorDiv.textContent = msg;
      errorDiv.classList.remove('hidden');
      rootEl.classList.remove(...CLASSES.container.default, ...CLASSES.container.active);
      rootEl.classList.add(...CLASSES.container.invalid);
    } else {
      errorDiv.classList.add('hidden');
    }
  };

  const validate = () => {
    if (isServerFile) {
      rootEl.classList.remove(...CLASSES.container.invalid);
      rootEl.classList.remove(...CLASSES.container.default);
      rootEl.classList.add(...CLASSES.container.active);
      if (errorDiv) errorDiv.classList.add('hidden');
      return true;
    }

    if (!input) return false;

    const isRequired = input.hasAttribute('required');
    const hasFile = input.files && input.files.length > 0;

    if (hasFile) {
      const file = input.files[0];
      if (file.size > MAX_SIZE) {
        setError('File is too large. Maximum size is 50MB.');
        return false;
      }
    }

    rootEl.classList.remove(...CLASSES.container.invalid);
    if (errorDiv) errorDiv.classList.add('hidden');

    if (isRequired && !hasFile) {
      rootEl.classList.remove(...CLASSES.container.default, ...CLASSES.container.active);
      rootEl.classList.add(...CLASSES.container.invalid);
      setError('This file is required.');
      return false;
    }

    if (hasFile) {
      rootEl.classList.remove(...CLASSES.container.invalid);
      rootEl.classList.remove(...CLASSES.container.default);
      rootEl.classList.add(...CLASSES.container.active);
    } else {
      rootEl.classList.remove(...CLASSES.container.active, ...CLASSES.container.invalid);
      rootEl.classList.add(...CLASSES.container.default);
    }
    return true;
  };

  rootEl.validate = validate;

  if (isServerFile) {
    validate();
    return;
  }

  if (!input || !defaultView || !selectedView || !filenameEl) {
    return;
  }

  const updateUI = (file) => {
    requestAnimationFrame(() => {
      setError('');

      if (file) {
        if (file.size > MAX_SIZE) {
          input.value = '';
          setError('File is too large. Maximum size is 50MB.');
          return;
        }

        rootEl.classList.remove(...CLASSES.container.default, ...CLASSES.container.invalid);
        rootEl.classList.add(...CLASSES.container.active);

        defaultView.classList.add('hidden');
        selectedView.classList.remove('hidden');
        filenameEl.textContent = file.name;
        
        clearBtn?.focus();
      } else {
        rootEl.classList.remove(...CLASSES.container.active, ...CLASSES.container.invalid);
        rootEl.classList.add(...CLASSES.container.default);

        selectedView.classList.add('hidden');
        defaultView.classList.remove('hidden');
        
        input.value = '';
        triggerLabel?.focus();
      }
    });
  };

  input.addEventListener('change', () => {
    const file = input.files?.[0];
    updateUI(file);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      updateUI(null);
    });
  }

  if (triggerLabel) {
    triggerLabel.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        input.click();
      }
    });
  }
}